import { getAuth } from 'firebase/auth';
import { FaBell, FaUserCircle } from 'react-icons/fa';

export default function AdminHeader({ title }) {
  const auth = getAuth();
  const user = auth.currentUser;

  return (
    <div className="bg-white shadow-md px-6 py-4 flex justify-between items-center">
      <h1 className="text-2xl font-bold text-gray-800">{title}</h1>
      
      <div className="flex items-center space-x-4">
        <button className="relative text-gray-600 hover:text-gray-800">
          <FaBell className="text-xl" />
          <span className="absolute -top-1 -right-1 bg-red-500 text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">
            3
          </span>
        </button>
        
        <div className="flex items-center space-x-2">
          {user?.photoURL ? (
            <img 
              src={user.photoURL} 
              alt="Profile" 
              className="w-8 h-8 rounded-full"
            />
          ) : (
            <FaUserCircle className="text-3xl text-gray-600" />
          )}
          <span className="text-sm font-medium text-gray-700">
            {user?.displayName || user?.email}
          </span>
        </div>
      </div>
    </div>
  );
}
